import React, { useEffect, useState } from 'react';
import { Accordion, Container, Form, InputGroup, Spinner, Row, Col, Button, Modal, Alert } from 'react-bootstrap';
import DriverService from '../../services/DriverService';
import './style.css'; // Import CSS

const ChuyenKDTaiXeHoanTatComponent = () => {
    const [data, setData] = useState([]); // Dữ liệu gốc
    const [filteredData, setFilteredData] = useState([]); // Dữ liệu đã lọc
    const [loading, setLoading] = useState(true); // Trạng thái tải dữ liệu
    const [searchTerm, setSearchTerm] = useState(''); // Từ khóa tìm kiếm
    const [selectedDate, setSelectedDate] = useState(''); // Ngày khởi hành đã chọn
    const [showModal, setShowModal] = useState(false); // Trạng thái hiển thị modal
    const [message, setMessage] = useState(''); // Thông báo
    const [messageType, setMessageType] = useState(''); // success or danger
    const [editData, setEditData] = useState({
        ma_chuyen: '',
        km_dau: '',
        km_nhan_hang: '',
        km_cuoi: '',
        km_phat_sinh: '',
        ma_cx: ''
    }); // Dữ liệu cần chỉnh sửa

    // Load chuyến kinh doanh
    const fetchData = async () => {
        try {
            const response = await DriverService.loadChuyenKdTaiXeHT();
            setData(response); // Lưu dữ liệu vào state
            setFilteredData(response); // Khởi tạo dữ liệu đã lọc
        } catch (error) {
            console.error('Lỗi khi lấy dữ liệu:', error);
        } finally {
            setLoading(false); // Tắt trạng thái tải
        }
    };

    // Gọi API khi component được mount
    useEffect(() => {
        fetchData();
    }, []);

    // Tự động đóng Alert sau 5 giây
    useEffect(() => {
        if (message) {
            const timer = setTimeout(() => {
                setMessage('');
            }, 5000); // 5000ms = 5 giây

            // Cleanup function để tránh memory leaks khi component unmount
            return () => clearTimeout(timer);
        }
    }, [message]);

    // Lọc dữ liệu khi `searchTerm` hoặc `selectedDate` thay đổi
    useEffect(() => {
        const term = searchTerm.toLowerCase();
        const filtered = data.filter((item) => {
            const itemDate = new Date(item.ngay_van_chuyen).toISOString().split('T')[0];
            const matchesSearchTerm =
                item.diem_di.toLowerCase().includes(term) || item.diem_den.toLowerCase().includes(term);
            const matchesDate = selectedDate === '' || itemDate === selectedDate;
            return matchesSearchTerm && matchesDate;
        });
        setFilteredData(filtered);
    }, [searchTerm, selectedDate, data]);

    // Hiển thị modal khi bấm "Sửa thông tin"
    const handleShowModal = (item) => {
        setEditData({
            ma_chuyen: item.ma_chuyen,
            km_dau: item.km_dau,
            km_nhan_hang: item.km_nhan_hang,
            km_cuoi: item.km_cuoi,
            km_phat_sinh: item.km_phat_sinh,
            ma_cx: item.ma_cx
        });
        setShowModal(true);
    };

    // Xử lý việc cập nhật thông tin khi submit form
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Kiểm tra các điều kiện hợp lệ
            if (
                editData.km_dau > editData.km_nhan_hang ||
                editData.km_nhan_hang >= editData.km_cuoi 
            ) {
                setMessage('Thông tin km có sai sót.');
                setMessageType('danger');
                return;
            }
            if (editData.km_dau < 0 || editData.km_nhan_hang < 0 || editData.km_cuoi < 0) {
                setMessage('Km phải lớn hơn 0.');
                setMessageType('danger');
                return;
            }

            // Gọi API cập nhật thông tin
            await DriverService.capNhatKmKinhDoanh(editData);
            fetchData(); // Làm mới dữ liệu sau khi cập nhật
            setShowModal(false); // Đóng modal sau khi cập nhật thành công
            setMessage('Cập nhật thông tin thành công!');
            setMessageType('success');
        } catch (error) {
            console.error('Lỗi khi cập nhật thông tin:', error);
            setMessage('Lỗi khi cập nhật thông tin.');
            setMessageType('danger');
        }
    };

    // Hiển thị spinner khi dữ liệu đang tải
    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
                <p>Đang tải dữ liệu...</p>
            </Container>
        );
    }

    return (
        <Container fluid className="mt-5 xem-thong-tin-da-nhap">
            {/* Hiển thị thông báo nếu có message */}
            {message && (
                <Alert style={{ position: 'fixed', top: '80px', zIndex: '1001' }} variant={messageType} onClose={() => setMessage('')} dismissible>
                    {message}
                </Alert>
            )}
            <h2 className="text-center mb-4">Danh sách các chuyến xe</h2>

            {/* Thanh tìm kiếm */}
            <InputGroup className="mb-3">
                <Form.Control
                    type="text"
                    placeholder="Tìm kiếm theo mã chuyến hoặc biển kiểm soát..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)} // Cập nhật searchTerm
                />
            </InputGroup>

            {/* Chọn ngày khởi hành */}
            <InputGroup className="mb-3">
                <Form.Group controlId="selectedDate" className="w-100">
                    <Form.Label>Chọn ngày khởi hành</Form.Label>
                    <Form.Control
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                    />
                </Form.Group>
            </InputGroup>

            {/* Accordion hiển thị dữ liệu */}
            <Accordion>
                {filteredData.length === 0 ? (
                    <p className="text-center">Không tìm thấy chuyến xe nào.</p>
                ) : (
                    filteredData.map((item, index) => (
                        <Accordion.Item key={index} eventKey={index.toString()}>
                            <Accordion.Header>
                                <div className="d-flex justify-content-between w-100">
                                    <span>{item.ma_chuyen}</span>
                                    <span>{item.bien_kiem_soat}</span>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col md={12}>
                                        <p><strong>Ngày vận chuyển:</strong> {new Date(item.ngay_van_chuyen).toLocaleDateString()}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <p><strong>Điểm đi:</strong> {item.diem_di}</p>
                                        <p><strong>Điểm đến:</strong> {item.diem_den}</p>
                                        <p><strong>Trạng thái:</strong> {item.trang_thai}</p>
                                        <p><strong>Thời gian nhận hàng:</strong> {item.thoi_gian_nhan_hang ? new Date(item.thoi_gian_nhan_hang).toLocaleString() : 'N/A'}</p>
                                        <p><strong>Thời gian kết thúc:</strong> {item.thoi_gian_ket_thuc ? new Date(item.thoi_gian_ket_thuc).toLocaleString() : 'N/A'}</p>
                                    </Col>
                                    <Col md={6}>
                                        <p><strong>Km đầu:</strong> {item.km_dau}</p>
                                        <p><strong>Km nhận hàng:</strong> {item.km_nhan_hang || 'N/A'}</p>
                                        <p><strong>Km cuối:</strong> {item.km_cuoi || 'N/A'}</p>
                                        <p><strong>Km phát sinh:</strong> {item.km_phat_sinh || 'N/A'}</p>
                                        <p><strong>Thời gian hoàn thành:</strong> {item.thoi_gian_hoan_thanh ? new Date(item.thoi_gian_hoan_thanh).toLocaleString() : 'N/A'}</p>
                                    </Col>
                                </Row>
                                <Button variant="warning" onClick={() => handleShowModal(item)}>Sửa thông tin</Button>
                            </Accordion.Body>
                        </Accordion.Item>
                    ))
                )}
            </Accordion>

            {/* Modal chỉnh sửa thông tin */}
            <Modal className="xem-thong-tin-da-nhap" show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Sửa thông tin chuyến xe</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editData && (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label>Mã chuyến</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={editData.ma_chuyen}
                                    onChange={(e) => setEditData({ ...editData, ma_chuyen: e.target.value })}
                                    disabled
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Mã chuyến VTMan</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={editData.ma_cx}
                                    onChange={(e) => setEditData({ ...editData, ma_cx: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Km đầu</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={editData.km_dau}
                                    onChange={(e) => setEditData({ ...editData, km_dau: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Km nhận hàng</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={editData.km_nhan_hang}
                                    onChange={(e) => setEditData({ ...editData, km_nhan_hang: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Km cuối</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={editData.km_cuoi}
                                    onChange={(e) => setEditData({ ...editData, km_cuoi: e.target.value })}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Km phát sinh</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={editData.km_phat_sinh}
                                    onChange={(e) => setEditData({ ...editData, km_phat_sinh: e.target.value })}
                                />
                            </Form.Group>
                            <Button variant="primary" type="submit">Lưu thay đổi</Button>
                            <Button variant="secondary" onClick={() => setShowModal(false)}>Đóng</Button>
                        </Form>
                    )}
                </Modal.Body>
            </Modal>
        </Container>
    );
};

export default ChuyenKDTaiXeHoanTatComponent;
